module.exports = __webpack_public_path__ + "static/media/Isolation_Mode.6c2ddb71.svg";